const CHAT_LIST_CACHE_PREFIX = 'chats-v2-';
const LEGACY_CHAT_LIST_CACHE_PREFIX = 'chats-';

/** Returns the versioned cache key for the Principal conversation list. */
export const getChatListCacheKey = (userId?: number | string | null): string =>
    `${CHAT_LIST_CACHE_PREFIX}${userId}`;

/** Remove persisted conversation lists after a chat/group mutation. */
export const invalidateChatListCache = (userId?: number | string | null): void => {
    if (userId === undefined || userId === null) return;

    try {
        // The version bump drops principal caches created before request inboxes
        // were classified from the authoritative server-side request state.
        localStorage.removeItem(getChatListCacheKey(userId));
        localStorage.removeItem(`${LEGACY_CHAT_LIST_CACHE_PREFIX}${userId}`);
    } catch {
        // localStorage can be unavailable in private mode or a restricted WebView.
    }
};
